<p-table
  [hasList]="service.hasList"
  (add)="onAdd()"
  (delete)="onDelete($event)"
  (edit)="onEdit($event)"
  (onLazyLoad)="loadData($event)"
  (onPage)="pageChange($event)"
  (view)="onView($event)"
  [columns]="service.tableColumns"
  [first]="first"
  [globalSearch]="globalSearch"
  [hasActions]="service.hasActions"
  [hasAdd]="service.hasAdd"
  [hasDelete]="service.hasDelete"
  [hasEdit]="service.hasEdit"
  [hasView]="service.hasView"
  [loading]="loading()"
  [rows]="rows"
  [title]="service.title"
  [totalRecords]="total"
  [value]="list"
  [selectionMode]="'single'"
  [dataKey]="'id'"
  tableStyleClass="table table-hover"
  paginatorPosition="bottom">
  <ng-template #cells let-data>
    @for (col of service.tableColumns; track col) {
      @switch (col.fieldName) {
        @case ('actions') {
          <td>
            <a [routerLink]="[Resources.PropertyContractsDetails | resourceById:data.id]"
               ngbTooltip="{{'INVOICES.DETAILS' | translate}}"
               >
              <span class="text-primary">
                {{ 'INVOICES.DETAILS' | translate }}
              </span>
            </a>
          </td>
        }
        @default {
          <td>
            <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
          </td>
        }
      }
    }
  </ng-template>
</p-table>
